// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
// import Vue from 'vue'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'

// import Translate from '@/service/translate'

// todo
// cssVars()

import { auth, idle, custom } from '@/service'
import * as _ from 'lodash'
import * as moment from 'moment-timezone'
import * as forge from 'node-forge'
import Toastr from 'vue-toastr'
import Filters from './filter'
import XLSX from 'xlsx'
// import { VclFacebook } from 'vue-content-loading';
// import { saveAs } from 'file-saver';
// import VJsoneditor from 'v-jsoneditor/src/index'
// import signalR from '@aspnet/signalr' //
const signalR = require('@aspnet/signalr') // not supporting ES6 modules

// import store from './vuex/store'

// load chart
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

import 'vue-select/dist/vue-select.css';
require('vue-toastr/src/vue-toastr.scss');

(async () => {
  console.log('F1Security Secaas Console App. v1.0');

  // should before then Vue.use()
  router.beforeEach((to, from, next) => {
    console.log('[router]', `${from.path}`, from.params, ' to ', `${to.path}`, to.params);
    // 로그인 여부 확인
    if(!to.matched.some(record => record.meta.requiresAuth) || auth.loggedIn()) { next(); }
    else {
      console.log('[router]', 'authentication required.');
      next({ path: '/auth/login', query: { redirect: to.fullPath } });
    }
  })
  // Vue.use('VclFacebook', VclFacebook)
  Vue.use(Filters)
  Vue.use(BootstrapVue)
  Vue.use(Toastr)
  Vue.use(_)
  Chartkick.options = {
    height: "400px",
    colors: ["green", "blue",'yellow'],
  }
  Vue.use(Chartkick.use(Chart))
  // Vue.use(VJsoneditor)
  // Vue.use(Translate)

  await auth.init();
  await custom.Setting_Call(); // cusotm logo and slogan

  //const store = new Vuex.Store();
  /* eslint-disable no-new */
  let vue = new Vue({
    el: '#app',
    // store,
    router,
    template: '<App/>',
    components: { App },
    beforeCreate () {
    },
  });

  window['log'] = console.log; // 반드시 출력할 로그 함수
  if(location.hostname == 'localhost') {
    window['moment'] = moment;
    window['forge'] = forge;
    window['router'] = router;
    window['vue'] = vue;
    // window['vuex'] = Vuex;
    window['auth'] = auth;
    window['idle'] = idle;
    window['xlsx'] = XLSX;
    // window['saveAs'] = saveAs;
    // window['tr'] = Translate;
    window['signalR'] = signalR;
  } else {
    window['_rc_'] = () => console.log; // 로그함수 백업
    // console.log = () => {}; // 로깅 감추기
  }
})();
